import AppConstants from '../constants/AppConstants';

export const initialState = {
    item: {},
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.NOTIFICATION_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.NOTIFICATION_SUCCESS:
            return {
                ...state,
                loading: false,
                item: action.item
            };

        case AppConstants.NOTIFICATION_FAIL:
            return {
                ...state,
                loading: false
            };

        case AppConstants.NOTIFICATION_CLOSE:
            return {
                ...state,
                loading: true
            };

        case AppConstants.NOTIFICATION_CLOSE_SUCCESS:
            return {
                ...state,
                item: {},
                loading: false
            };

        default:
            return state;
    }
};
